// Unpublished Work © 2025 Deere & Company.

import React from 'react';
import {connect} from 'react-redux';
import {closeDialog as closeReduxDialog} from 'Store/actions/dialogs';
import dialogTypes from 'Ui/components/common/dialog-types';
import PropTypes from 'prop-types';
import JobsSettings from 'Src/ui-core/components/settings/labor/jobs-settings';
import {Dialog, Box} from '@deere/isg.component-library';

function JobsSettingsDialog(props) {
    const {
        getUpdatedJobTemplates,
        closeDialog,
        translations
    } = props;

    async function onDismiss() {
        await getUpdatedJobTemplates();
        closeDialog();
    }

    return (
        <Dialog
            closeHandler={onDismiss}
            open={true}
            title={translations.JOBS}
            translations={translations}
            width='lg'
        >
            <Box
                display='flex'
                height='70vh'
            >
                <JobsSettings translations={translations}/>
            </Box>
        </Dialog>
    );
}

JobsSettingsDialog.propTypes = {
    closeDialog: PropTypes.func,
    getUpdatedJobTemplates: PropTypes.func,
    translations: PropTypes.translations
};

export function mapDispatchToProps(dispatch) {
    return {
        closeDialog() {
            dispatch(closeReduxDialog(dialogTypes.JOBS_SETTINGS_DIALOG));
        }
    };
}

export default connect(null, mapDispatchToProps)(JobsSettingsDialog);
